import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useSidePanelStore } from './side-panel.store'

const PHONE = '(max-width: 1023px)'

// The Campaign brief beside the campaign chat: expanded to half the page, or a sheet on a phone, like the copy document.
export const useBriefPanelStore = defineStore('campaign-brief-panel', () => {
  const expanded = ref(false)
  const sheet = ref(false)
  // The parts to scroll to and flash; `at` makes the same ones flash again.
  const shown = ref<{ readonly keys: readonly string[]; readonly at: number } | null>(null)

  const point = (keys: readonly string[]) => {
    if (keys.length === 0) return
    useSidePanelStore().open = true
    shown.value = { keys, at: Date.now() }
  }

  const show = (keys: readonly string[]) => {
    if (window.matchMedia(PHONE).matches) sheet.value = true
    point(keys)
  }

  return { expanded, sheet, shown, point, show }
})
